import { render, staticRenderFns } from "./WaistDataItem.vue?vue&type=template&id=3a8973c4&scoped=true&"
import script from "./WaistDataItem.vue?vue&type=script&lang=js&"
export * from "./WaistDataItem.vue?vue&type=script&lang=js&"
import style0 from "./WaistDataItem.vue?vue&type=style&index=0&id=3a8973c4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8973c4",
  null
  
)

export default component.exports